import { render, staticRenderFns } from "./StrategicReport.vue?vue&type=template&id=4066c412&scoped=true"
import script from "./StrategicReport.vue?vue&type=script&lang=js"
export * from "./StrategicReport.vue?vue&type=script&lang=js"
import style0 from "./StrategicReport.vue?vue&type=style&index=0&id=4066c412&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4066c412",
  null
  
)

export default component.exports